import elayout from "./layout.module.scss";
import {
  Avatar,
  Button,
  Dropdown,
  FloatButton,
  Form,
  Input,
  Menu,
  MenuProps,
  message,
  Modal,
  Popover,
  Segmented,
  Select,
  Spin,
  Tag,
  Tooltip,
} from "antd";
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import LoadingIcon from "../components/Icon/LoadingIcon";
import http from "../http";
import { useUserInfo } from "../context/ThemeContext";
import Image from "next/image";
import {
  CodeOutlined,
  DeleteOutlined,
  EllipsisOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  FormOutlined,
  MessageOutlined,
  ReloadOutlined,
  RubyOutlined,
} from "@ant-design/icons";
import { useRouter } from "next/router";
import {
  deleteWiki,
  editWikiConfig,
  getRepoWikiList,
  resetWiki,
  wikiData,
} from "../components/api/wiki";
import LoginBox from "../components/common/LoginBox";
import Login from "../components/common/login";
import PointsShareModal from "../components/common/PointsShareModal";
import styles from "./layout.module.scss";
interface UserCommonData {
  commonData: {
    deepThinking: boolean;
    wikiList: MenuItem[];
    showLogin: boolean;
    freeTimes: number;
  };
  selectWiki: any;
  changeCommonData: (data: any, wikiMenu?: boolean) => void;
  changeSelectWiki: (wiki: any) => void;
}
type MenuItem = Required<MenuProps>["items"][number];
const CommonDataContext = createContext<UserCommonData | undefined>(undefined);
interface UserWikiData {
  selectWiki: any;
  changeSelectWiki: (wiki: any) => void;
}
const WikiDataContext = createContext<UserWikiData | undefined>(undefined);
export default function ELayout(props: { children: JSX.Element }) {
  const router = useRouter();
  const { TextArea } = Input;
  const [form] = Form.useForm();
  const [modal, contextHolder] = Modal.useModal();
  const { userInfo, getUserInfo } = useUserInfo();
  const [isLoading, setIsLoading] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const [commonData, setCommonData] = useState<{
    deepThinking: boolean;
    wikiList: MenuItem[];
    showLogin: boolean;
    freeTimes: number;
  }>({
    deepThinking: localStorage.getItem("deepThinking") === "true",
    wikiList: [],
    showLogin: false,
    freeTimes: 0,
  });
  const [selectWiki, setSelectWiki] = useState<any>();
  const github_id = useRef("");
  const gitee_code = useRef("");
  const loginBox = useRef<any>();
  const login = useRef<any>();
  const dropDownData = useRef<any>({});

  useEffect(() => {
    const token = localStorage.getItem("token");
    const deepThinking = localStorage.getItem("deepThinking") === "true";
    changeCommonData({ deepThinking: deepThinking });
    if (!token) {
      return;
    }
    getInfo();
  }, []);
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (userInfo?.login && !!token) {
      setTimeout(() => {
        github_id.current = sessionStorage.getItem("github_id") || "";
        github_id.current && linkGithub();
        gitee_code.current = sessionStorage.getItem("gitee_id") || "";
        gitee_code.current && linkGiee();
      }, 100);
      getRepoWikiList().then((res) => {
        changeCommonData({ wikiList: res.data.items }, true);
      });
      // getFreeTimes().then((res) => {
      //   changeCommonData({ freeTimes: res.data.count });
      // });
    }
    if (!(userInfo?.login || !!token)) {
      setCommonData({
        deepThinking: localStorage.getItem("deepThinking") === "true",
        wikiList: [],
        showLogin: false,
        freeTimes: 0,
      });
      openNotification();
    }
  }, [userInfo?.login]);
  useEffect(() => {
    if (commonData.showLogin) {
      login.current?.show();
    }
  }, [commonData]);

  const changeCommonData = (data: any, wikiMenu: boolean = false) => {
    if (wikiMenu) {
      const arr = data.wikiList.map((item: wikiData) => {
        let items: MenuProps["items"] = [
          {
            key: "edit",
            label: <span>修改配置</span>,
            icon: <FormOutlined />,
            onClick: (e) => {
              e.domEvent.stopPropagation();
              form.setFieldsValue({
                name: dropDownData.current.name,
                description: dropDownData.current.description,
                excluded_dirs:
                  dropDownData.current.excluded_dirs?.join(",") || "",
                excluded_files:
                  dropDownData.current.excluded_files?.join(",") || "",
                others: JSON.stringify(dropDownData.current.others),
              });
              modal.confirm({
                title: "修改配置",
                centered: true,
                icon: null,
                width: 500,
                content: (
                  <Form
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                    autoComplete="off"
                    form={form}
                  >
                    <Form.Item
                      label="名称"
                      name="name"
                      normalize={(value) => value?.trim()}
                    >
                      <Input placeholder="请输入名称" />
                    </Form.Item>
                    <Form.Item
                      label="描述"
                      name="description"
                      normalize={(value) => value?.trim()}
                    >
                      <TextArea placeholder="请输入描述" rows={5} />
                    </Form.Item>
                    <Form.Item
                      label="排除目录"
                      name="excluded_dirs"
                      normalize={(value) => value?.trim()}
                    >
                      <Input placeholder="例如 page,public" />
                    </Form.Item>
                    <Form.Item
                      label="排除文件"
                      name="excluded_files"
                      normalize={(value) => value?.trim()}
                    >
                      <Input placeholder="例如 test.ts,.py" />
                    </Form.Item>
                  </Form>
                ),
                onOk: () => {
                  return new Promise<void>((resolve, reject) => {
                    form.validateFields().then((values) => {
                      if (
                        values.excluded_dirs?.includes("，") ||
                        values.excluded_files?.includes("，")
                      ) {
                        message.error("请勿输入中文逗号");
                        reject();
                        return;
                      }
                      const params: any = {
                        name: values.name,
                        description: values.description,
                        excluded_dirs: values.excluded_dirs
                          ? values.excluded_dirs.split(",")
                          : [],
                        excluded_files: values.excluded_files
                          ? values.excluded_files.split(",")
                          : [],
                        wiki_id: dropDownData.current.uuid,
                        others: values.others ? JSON.parse(values.others) : {},
                      };
                      editWikiConfig(params).then((result) => {
                        if (result.status) {
                          message.success(result.message);
                          resolve();
                          getRepoWikiList().then((res) => {
                            changeCommonData(
                              {
                                wikiList: res.data.items,
                              },
                              true
                            );
                            changeSelectWiki({
                              ...res.data.items.find(
                                (item) =>
                                  item.uuid === selectWiki?.uuid
                              ),
                            });
                          });
                        } else {
                          message.error(result.message);
                          reject();
                        }
                      });
                    });
                  });
                },
              });
            },
          },
        ];
        if (item.stage_status.generate === "done") {
          items = [
            {
              key: "reset",
              label: <span>重新生成</span>,
              icon: <ReloadOutlined />,
              onClick: (e) => {
                e.domEvent.stopPropagation();
                modal.confirm({
                  title: "重新生成wiki",
                  centered: true,
                  content: "是否重新生成wiki，重新生成后之前的wiki数据将丢失",
                  onOk: () => {
                    return new Promise<void>((resolve, reject) => {
                      resetWiki(dropDownData.current.uuid).then((result) => {
                        if (result.status) {
                          resolve();
                          message.success(result.message);
                          getRepoWikiList().then((res) => {
                            changeCommonData(
                              {
                                wikiList: res.data.items,
                              },
                              true
                            );
                            changeSelectWiki(
                              res.data.items.find(
                                (item) => item.uuid === selectWiki?.key
                              )
                            );
                          });
                        } else {
                          message.error(result.message);
                          reject();
                        }
                      });
                    });
                  },
                });
              },
            },
            ...items,
          ];
        }
        if (item.stage_status.generate === "done") {
          items = [
            {
              key: "pdf",
              label: <span>下载pdf</span>,
              icon: <FilePdfOutlined />,
              onClick: (e) => {
                e.domEvent.stopPropagation();
                window.open(`/pdf/${dropDownData.current.uuid}`);
              },
            },
            ...items,
          ];
        }
        items = [
          ...items,
          {
            key: "del",
            danger: true,
            label: <span>删除Wiki</span>,
            icon: <DeleteOutlined />,
            onClick: (e) => {
              e.domEvent.stopPropagation();
              modal.confirm({
                title: "删除Wiki",
                centered: true,
                content: "是否确认删除wiki，删除成功后的wiki数据将丢失",
                onOk: () => {
                  return deleteWiki(dropDownData.current.uuid).then(() => {
                    getRepoWikiList().then((res) => {
                      changeCommonData(
                        {
                          wikiList: res.data.items,
                        },
                        true
                      );
                      message.success("删除成功");
                      router.push("/wiki");
                    });
                  });
                },
              });
            },
          },
        ];
        return {
          value: item.uuid,
          key: item.uuid,
          ...item,
          label: (
            <div className={styles.menuItem} title={item.name}>
              <span className={styles.menuText}>{item.name}</span>
              <div className={styles.extra}>
                <Dropdown menu={{ items }} trigger={["click"]}>
                  <Button
                    onClick={(e) => {
                      dropDownData.current = item;
                      e.stopPropagation();
                      e.preventDefault();
                    }}
                    type="text"
                    icon={<EllipsisOutlined />}
                  ></Button>
                </Dropdown>
              </div>
            </div>
          ),
        };
      });
      setCommonData((prev) => ({
        ...prev,
        ...data,
        wikiList: arr,
      }));
    } else {
      setCommonData((prev) => ({
        ...prev,
        ...data,
      }));
    }
  };
  const changeSelectWiki = (item: any) => {
    setSelectWiki(item);
  };
  const linkGiee = () => {
    http
      .post(`/api/v1/thirdparty/gitee/link?gitee_id=${gitee_code.current}`)
      .then((data: any) => {
        if (data.status) {
          getInfo();
          sessionStorage.setItem("gitee_id", "");
        } else {
          message.error(data.message);
        }
      });
  };
  const linkGithub = () => {
    http
      .post(`/api/v1/thirdparty/github/link?github_id=${github_id.current}`)
      .then((data: any) => {
        if (data.status) {
          getInfo();
          sessionStorage.setItem("github_id", "");
        } else {
          message.error(data.message);
        }
      });
  };
  const getInfo = useCallback(() => {
    setIsLoading(true);
    getUserInfo().finally(() => {
      setIsLoading(false);
    });
  }, []);
  const openNotification = () => {
    loginBox.current?.showLogin();
  };
  const loginSucccess = () => {
    getInfo();
    login.current?.close();
  };
  return (
    <div className={elayout.elayout}>
      <CommonDataContext.Provider
        value={{ commonData, selectWiki, changeCommonData, changeSelectWiki }}
      >
        <WikiDataContext.Provider value={{ selectWiki, changeSelectWiki }}>
          <div className={elayout.main_content}>{props.children}</div>
          <PointsShareModal
            open={shareOpen}
            onClose={() => setShareOpen(false)}
          />
        </WikiDataContext.Provider>
      </CommonDataContext.Provider>
      <Popover
        placement="left"
        content={
          <div className={elayout.customerService}>
            <div className={elayout.smallImageContainer}>
              <Image
                src="/customer2.jpg"
                alt="Small decorative image"
                className={elayout.smallImage}
                width={100} // 根据实际图片尺寸设置
                height={100}
              />
            </div>
            <div>
              <p className={elayout.customerText}>
                扫码联系客服/进AI编程交流群
              </p>
            </div>
          </div>
        }
      >
        <FloatButton
          icon={
            <Image
              src="/chat/wework.png"
              alt="WeChat"
              width={24} // 根据实际图片尺寸设置
              height={18}
            />
          }
          onClick={() => {}}
          style={{ bottom: 200 }}
        />
      </Popover>
      <Popover placement="left" content="分享邀请赚积分">
        <FloatButton
          icon={<RubyOutlined />}
          onClick={() => setShareOpen(true)}
          style={{ bottom: 150 }}
        />
      </Popover>
      <LoginBox
        ref={loginBox}
        gotoLogin={(openId) => {
          login.current?.show(openId);
        }}
        loginSuccess={loginSucccess}
      />
      <Login
        ref={login}
        loginSucccess={loginSucccess}
        closeBox={() => changeCommonData({ showLogin: false })}
      ></Login>
      <Spin
        spinning={isLoading}
        indicator={<LoadingIcon size={48} />}
        fullscreen
      />
      {contextHolder}
    </div>
  );
}
export const useCommonData = (): UserCommonData => {
  const context = useContext(CommonDataContext);
  if (!context) {
    throw new Error("useThread must be used within a ThreadProvider");
  }
  return context;
};
export const useWikiData = (): UserWikiData => {
  const context = useContext(WikiDataContext);
  if (!context) {
    throw new Error("useThread must be used within a ThreadProvider");
  }
  return context;
};
